export const IMG_OBJECT_FIT = 'cover'
